module.exports = __webpack_public_path__ + "img/order_done.db3626bb.svg";